module.exports = {
	"enable": false,
	"carbon_ad_src": "https://cdn.carbonads.com/carbon.js?serve=CK7D5KQW&placement=inboxkittencom",
	"placement": ["InboxKittenLanding"]
}



//////////////////
// WEBPACK FOOTER
// ./config/carbonads.js
// module id = dYxp
// module chunks = 1